/* eslint-disable react/style-prop-object */
import { Breadcrumb, Dropdown, Space } from "antd";
import Button from "../Helpers/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import trans from "../../utils";
import { useSelector } from "react-redux";
import ExportDropdown from "./AntDropdown";
import { DownOutlined } from "@ant-design/icons";
import usePermission from "../../hooks/usePermission";
import ModeToggle from "../OfflineSetup/ModeToggle";
import { useContext } from "react";
import { popupcontext } from "../../context/Popupscontext";

export default function BreadCrumb({
	title,
	add,
	onClick,
	type,
	text,
	secClick,
	secButton,
	secLoading = false,
	prLoading = false,
	setSelectedKey,
	selectedKey,
	selected,
	extra,
}) {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const inf = useSelector((state) => state.users.user);
	const { view } = usePermission("DASHBOARD");
	// Generate breadcrumb items from pathname
	const getBreadcrumbItems = () => {
		const pathSegments = pathname.split("/").filter((i) => i);

		const items = [
			{
				title: (
					<span
						className="bread-crumb-home text-primary"
						onClick={() => {
							view ? navigate("/dashboard") : navigate("/");
						}}
					>
						{view ? trans("dashboard") : trans("account")}
					</span>
				),
			},
			...pathSegments.map((seg, index) => {
				// Build path up to this segment
				const url = "/" + pathSegments.slice(0, index + 1).join("/");

				const isLast = index === pathSegments.length - 1;

				return {
					title: isLast ? (
						<span className="bread-crumb-last">{trans(seg)}</span>
					) : seg === "reports" ? (
						<span
							className="bread-crumb-home text-primary"
							onClick={() => navigate(url)}
						>
							{trans(seg)}
						</span>
					) : (
						<span>{trans(seg)}</span>
					),
				};
			}),
		];

		return items;
	};
	const usersitems = [
		{
			label: trans("Users"),
			key: "1",
		},
		{
			label: trans("Field Staff"),
			key: "2",
		},
		{
			label: trans("Customers"),
			key: "3",
		},
	];
	const fieldstaffitems = [
		{
			label: trans("Add single tecnician"),
			key: "1",
		},
		{
			label: trans("Bulk Upload"),
			key: "2",
		},
	];

	const handleMenuClick = (e) => {
		console.log("click", e?.key);
		setSelectedKey(e?.key);
	};
	const handleFieldStaffMenuClick = (e) => {
		if (e.key === "1") {
			onClick();
		} else {
			secClick();
		}
	};
	const menuProps = {
		items: usersitems,
		onClick: handleMenuClick,
		selectable: true, // ✅ allows showing check mark
		selectedKeys: selectedKey ? [selectedKey] : [],
	};
	const fieldstaffmenuProps = {
		items: fieldstaffitems,
		onClick: handleFieldStaffMenuClick,
	};
	return (
		<div className="bg-white p-16 border-bottom">
			<div className="flex-between">
				<div>
					<Breadcrumb
						separator={
							<img
								src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Separator.svg`}
								alt="arrow"
							/>
						}
						items={getBreadcrumbItems()}
					/>
				</div>

				{inf.administrator === true ||
				inf.deviceLimit > 0 ||
				inf.deviceLimit === -1 ||
				inf.userLimit > 0 ? (
					<div className="flex-between gap-8">
						{type === "offline-setup" && <ModeToggle />}

						{secButton && (
							<Button
								text={trans(secButton)}
								onClick={secClick}
								type={"default"}
								loading={secLoading}
							/>
						)}
						{extra}
						{selected === "users" && (
							<Dropdown menu={menuProps} trigger={["click"]}>
								<Button>
									<Space>
										{trans("User Type")}
										<DownOutlined />
									</Space>
								</Button>
							</Dropdown>
						)}
						{add && selectedKey !== "2" && (
							<Button
								text={add}
								onClick={onClick}
								type={"primary"}
								loading={prLoading}
							/>
						)}
						{add && selectedKey === "2" && (
							<Dropdown menu={fieldstaffmenuProps} trigger={["click"]}>
								<Button type={"primary"}>
									<Space>
										{trans("Add new technician")}
										<DownOutlined />
									</Space>
								</Button>
							</Dropdown>
						)}

						{type === "reports" && pathname !== "/reports" && (
							<ExportDropdown />
						)}
					</div>
				) : (
					<div>
						{type === "reports" && pathname !== "/reports" && (
							<ExportDropdown />
						)}
					</div>
				)}
			</div>
		</div>
	);
}
